<template>
    <div>

        <div class="flex-grid__item--third-label">Select Your Comparison</div>
        <div class=" u-margin-bottom-30">
            <div class="a-form-inputs a-form-inputs--half a-form-inputs--half-to">
                <div class="a-form-inputs__container">
                    <select v-model="from">
                        <option value="dayOne">Day One</option>
                        <option value="final">Final Reserve</option>
                        <option value="paid">Paid</option>
                    </select>
                </div>
                <div class="a-form-inputs__to">vs</div>
                <div class="a-form-inputs__container">
                    <select v-model="to">
                        <option v-for="(label, key) in toOptions" :value="key">{{label}}</option>
                    </select>
                </div>
            </div>
        </div>
        <p v-if="showPaidAlert">
            <strong class="a-form-inputs--error">
                You are comparing paid values but of your {{totalClaims}} claims none has been marked as paid.
                You can still compare against final reserve or make another selection.
            </strong>
        </p>
        <p v-if="hasNoClaims">
            <strong>
                No claims returned for your current search.
            </strong>
        </p>
    </div>
</template>

<script>
    import _ from 'lodash';
    import Control from "components/form/Control";
    import {mapGetters} from "vuex";

    export default {
        name: 'from-to',
        components: {
            Control
        },
        computed: {
            ...mapGetters('reserves/compare', [
                'from',
                'to',
                'totalClaims',
                'hasPaidClaims',
                'numberOfPaid',
                'hasClaims',
                'hasNoClaims'
            ]),
            from: {
                get() {
                    return this.$store.getters['reserves/compare/from'];
                },
                set(value) {
                    return this.$store
                        .dispatch('reserves/compare/update', {
                            key: 'from',
                            value
                        });
                }
            },
            to: {
                get() {
                    return this.$store.getters['reserves/compare/to'];
                },
                set(value) {
                    return this.$store
                        .dispatch('reserves/compare/update', {
                            key: 'to',
                            value
                        });
                }
            },
            toOptions() {
                const labels = {
                    dayOne: 'Day One',
                    final: 'Final Reserve',
                    paid: 'Paid',
                };
                return _.pickBy(labels, (label, key) => {
                    return key !== this.from
                });
            },
            isComparingPaid() {
                return (this.to === 'paid' || this.from === 'paid')
            },
            showPaidAlert() {
                return this.isComparingPaid && !this.hasPaidClaims && this.hasClaims;
            }
        }
    }
</script>


// WEBPACK FOOTER //
// FromTo.vue?94e649ac